import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import salonService from "../../services/SalonService";
import { useSalon } from "../../context/SalonContext";
import GlobalLoader from "../loadingIndicator/GlobalLoader";
import "./LoyaltyWallet.css";
import {
    FaWallet, FaHistory, FaGift, FaArrowDown, FaArrowUp,
    FaCoins, FaInfoCircle, FaChevronRight
} from "react-icons/fa";

export default function LoyaltyWallet({ salonUuid: propSalonUuid }) {
    const navigate = useNavigate();
    const { salonUuid, customerId, salonName } = useSalon();

    const [wallet, setWallet] = useState(null);
    const [config, setConfig] = useState(null);
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);

    const finalSalonUuid = propSalonUuid || salonUuid || localStorage.getItem("SALON_UUID");

    useEffect(() => {
        loadWallet();
    }, []);

    const loadWallet = async () => {
        try {
            const res = await salonService.getCustomerLoyaltyWallet(finalSalonUuid, customerId);
            setWallet(res.data.wallet);
            setConfig(res.data.config);
            setTransactions(res.data.transactions || []);
        } catch (e) {
            console.error("Wallet load failed", e);
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (date) => {
        return new Date(date).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric"
        });
    };

    if (loading) return <GlobalLoader />;

    return (
        <div className="loyalty-page-wrapper">
            <div className="loyalty-content-container py-4">
                {/* Premium Wallet Card */}
                <div className="premium-wallet-card shadow-lg">
                    <div className="card-top">
                        <FaCoins className="coin-icon-float" />
                        <span className="card-label">AVAILABLE BALANCE</span>
                    </div>

                    <div className="points-display">
                        <span className="points-number">{wallet?.pointsBalance || 0}</span>
                        <span className="points-text">Points</span>
                    </div>

                    <div className="wallet-footer-info">
                        <div className="value-equivalent">
                            <FaWallet className="me-2" />
                            Equivalent to <strong>₹{wallet?.pointsBalance || 0}</strong>
                        </div>
                    </div>
                </div>

                {/* Rules Section */}
                {config && (
                    <div className="loyalty-rules-section">
                        <div className="section-header-mini">
                            <FaInfoCircle className="me-2" /> Earning & Redemption
                        </div>
                        <div className="rules-grid">
                            <div className="rule-item">
                                <div className="rule-icon-box earn">
                                    <FaGift />
                                </div>
                                <div className="rule-details">
                                    <span className="rule-label">Earn</span>
                                    <span className="rule-value">{config.pointsEarned} Pts</span>
                                    <span className="rule-sub">per ₹{config.spendAmount} spent</span>
                                </div>
                            </div>
                            <div className="rule-item">
                                <div className="rule-icon-box redeem">
                                    <FaCoins />
                                </div>
                                <div className="rule-details">
                                    <span className="rule-label">Redeem</span>
                                    <span className="rule-value">{config.maxRedeemPercentage}%</span>
                                    <span className="rule-sub">max per booking</span>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Transactions Section */}
                <div className="transactions-section">
                    <div className="section-title-premium">
                        <FaHistory className="me-2" /> Recent Activity
                    </div>

                    {transactions.length === 0 ? (
                        <div className="empty-state">
                            <div className="empty-icon">📂</div>
                            <p>No transactions recorded yet.</p>
                            <button className="btn btn-outline-primary btn-sm rounded-pill mt-2" onClick={() => navigate('/booking')}>
                                Start Booking to Earn
                            </button>
                        </div>
                    ) : (
                        <div className="premium-txn-list">
                            {transactions.map((txn) => {
                                const isEarn = txn.transactionType === "EARN";

                                return (
                                    <div
                                        className={`premium-txn-card ${txn.apntId ? 'clickable' : ''}`}
                                        key={txn.id}
                                        onClick={() => {
                                            if (!txn.apntId) return;
                                            navigate(`/appointment/${txn.apntId}`, {
                                                state: {
                                                    apntId: txn.apntId,
                                                    salonUuid: finalSalonUuid
                                                }
                                            });
                                        }}
                                    >
                                        <div className={`txn-type-indicator ${isEarn ? 'earn' : 'redeem'}`}>
                                            {isEarn ? <FaArrowDown /> : <FaArrowUp />}
                                        </div>

                                        <div className="txn-main-info">
                                            <div className="txn-reason-row">
                                                <span className="txn-reason">{txn.reason}</span>
                                                <div className={`txn-points-badge ${isEarn ? 'earn' : 'redeem'}`}>
                                                    {isEarn ? '+' : '-'}{txn.points}
                                                </div>
                                            </div>
                                            <div className="txn-meta-row">
                                                <span className="txn-date">{formatDate(txn.createdDate)}</span>
                                                {txn.apntId && (
                                                    <span className="view-booking-link">
                                                        View Details <FaChevronRight className="ms-1" size={10} />
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
